import { AvailableLineDataRefNode, DriverData, DriverDataItem, DriverNodeList, FormulaDriver, FreeStyleDriver } from '@futrli-sdk/predict';

export enum NonFinancialDriverType {
  FORMULA = 'formula',
  FREESTYLE = 'freestyle',
  GROUP = 'group',
}

export interface NonFinancialDriverValues {
  id: string;
  values: Record<string, string | null> // {"YYYY-MM-DD": '###.##'}
}

export interface FormulaNonFinancialDriver extends FormulaDriver {
  driver_type: NonFinancialDriverType;
}

export interface FreestyleNonFinancialDriver extends FreeStyleDriver {
  amounts: Record<string, string | null>; // {"YYYY-MM": '###.##'}
  driver_type: NonFinancialDriverType;
  output_occurs_on_day: number;
}

export interface NonFinancialDriverDataItem extends DriverDataItem {
  values: NonFinancialDriverValues;
}

export interface NonFinancialDriverData extends DriverData {
  data: NonFinancialDriverDataItem[];
}

export interface NonFinancialDriverNodeList extends DriverNodeList {
  driver_type: NonFinancialDriverType;
}

export interface NonFinancialDriverFormulaOptionsResponse {
  non_financial_drivers_and_groups: AvailableLineDataRefNode[];
}

// Saving
export interface FreestyleNonFinancialDriverSaveData {
  name: string;
  driver_group?: string | null;
  amounts: Record<string, string | number | null>; // {"YYYY-MM": '###.##'}
  output_occurs_on_day: number;
  decimal_display: number;
}

export interface FreestyleNonFinancialDriverUpdateData {
  name?: string;
  driver_group?: string | null;
  order?: number;
  amounts?: Record<string, string | number | null>; // {"YYYY-MM": '###.##'}
  output_occurs_on_day?: number;
}

export interface FormulaNonFinancialDriverSaveData {
  name: string;
  expression: string;
  output_frequency: 'daily' | 'monthly' | 'annually';
  output_occurs_on_day: number;
  output_occurs_on_month: number;
  driver_group?: string | null;
  decimal_display: number
}

export interface FormulaNonFinancialDriverUpdateData {
  name?: string;
  expression?: string;
  output_frequency?: 'daily' | 'monthly' | 'annually';
  output_occurs_on_day?: number;
  output_occurs_on_month?: number;
  driver_group?: string | null;
  order?: number;
}

export interface FormulaNonFinancialDriverError {
  error_code: string;
}

export interface NonFinancialDriverGroupSaveData {
  name: string;
  driver_ids: string[];
}

export interface NonFinancialDriverGroupUpdateData {
  name: string;
}

export interface NonFinancialDriverDuplicateData {
  name?: string;
}

